import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/profiles')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
